import en from './strapi-locales/en.json';
import fr from './strapi-locales/fr.json';
import de from './strapi-locales/de.json';
import it from './strapi-locales/it.json';
import el from './strapi-locales/el.json';

export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en: en,
        fr: fr,
        de: de,
        it: it,
        el: el,
    },
    warnHtmlMessage: false,
}));
